const module = {
  config: {
    name: 'feedback-suggestions-module',
    icon: 'ri-file-info-line',
    desc: '',
    group: 'Forum',
    layout: true
  },
  routes: [
    { name: 'feedback-suggestions', label: 'Kritik & Saran', icon: 'ri-file-text-line', path: '/feedback-suggestions', component: () => import('./feedback-suggestions.vue') }
    // { name: 'news', label: 'Berita', icon: 'ri-skip-right-fill', path: '/news', component:  }
  ]
}
export default module



// WEBPACK FOOTER //
// ./src/modules/feedback-suggestions/_index.js